import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FinesService } from 'src/app/core/services/fines.service';

@Component({
  selector: 'app-fines',
  templateUrl: './fines.component.html',
  styleUrls: ['./fines.component.css']
})
export class FinesComponent implements OnInit {

  isArabic!: boolean;
    @Input() finesList: any;
    userData: any;
    finesCount: any;
    finesHistorical?:boolean
  
     constructor(private route: Router, private storageService: StorageService,
        private actionPlanService: ActionPlanService, private commonService: CommonService, private finesService: FinesService
      ) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.finesHistorical =this.storageService.getSessionStorageData('finesHistorical');

    if (this.finesList && this.finesList.length > 0) {
      const currentUrl = this.route.url; // full current URL

      this.finesList.forEach((item: { isActive: boolean; link: string; }) => {
        // mark active if current URL includes the item's link
        if(this.finesHistorical && currentUrl.includes("fines/detail")){
          this.finesList[1].isActive = true;
        }else{
          item.isActive = currentUrl.includes(item.link);
        }
      });

      // Optional fallback: if no match, activate first item
      if (!this.finesList.some((item: { isActive: any; }) => item.isActive)) {
        this.finesList[0].isActive = true;
      }
    }

    this.finesService.finesCount$.subscribe(count => {
      if(count){
        this.finesCount = count;
      }else{
        this.finesCount = this.storageService.getSessionStorageData('finesCount');;
      }
    });
  }
   onListItemClick(selectedItemIdx: number) {
    this.finesList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
     if (this.finesList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.finesList[selectedItemIdx].link;
      this.route.navigate([path]);
    }
  }

}
